import { Column, DataGrid } from 'devextreme-react/data-grid';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Modal, ModalHeader } from 'reactstrap';
import { getPeron, updatePlatform } from '../api';
import PeronSecimi from './PeronSecimi';

const PeronGuncelle = ({
    isOpen,
    setIsOpen,
    groupageDetails,
    detail,
    onFilter,
    selectedVehicles
}) => {
    const [selectedRow, setSelectedRow] = useState(null);
    const peronRef = useRef()

    // Gruplandırılmış veriyi hazırla - useMemo ile gereksiz hesaplamayı önle
    const groupedData = useMemo(() => {
        if (!groupageDetails?.chassis_details) return [];

        // Lokasyon ve perona göre gruplama
        const groupedMap = groupageDetails.chassis_details.reduce((acc, item) => {
            const key = `${item.exit_warehouse_id}-${item.groupage_peron}`;
            if (!acc[key]) {
                acc[key] = {
                    nereden: item.exit_warehouse,
                    mevcut_peron: item.groupage_peron,
                    count: 1,
                    exit_warehouse_id: item.exit_warehouse_id,
                    chassis_details: [item.chassis_no]
                };
            } else {
                acc[key].count++;
                acc[key].chassis_details.push(item.chassis_no);
            }
            return acc;
        }, {});

        // Object'i array'e çevir
        return Object.values(groupedMap);
    }, [groupageDetails?.chassis_details]);

    // Check if selected row's vehicles have all exited
    const selectedRowVehiclesExited = useMemo(() => {
        if (selectedRow === null || !groupedData[selectedRow]) return false;

        const selectedChassisNos = groupedData[selectedRow].chassis_details;
        const selectedVehicles = groupageDetails?.chassis_details?.filter(
            item => selectedChassisNos.includes(item.chassis_no)
        );

        return selectedVehicles?.every(item =>
            item.door_exit_date !== null &&
            item.door_exit_date !== undefined &&
            item.door_exit_date !== ""
        );
    }, [selectedRow, groupedData, groupageDetails?.chassis_details]);

    // Add useEffect to automatically select single row
    useEffect(() => {
        if (groupedData.length === 1 && isOpen.peronGuncelle) {
            getPeron(groupedData[0].exit_warehouse_id);
            setSelectedRow(0);
        }
    }, [groupedData, isOpen]);

    // Satır tıklama işleyicisi - useCallback ile gereksiz render'ı önle
    const handleRowClick = useCallback((index) => {
        // Check if vehicles in this row have exited
        const rowVehicles = groupageDetails?.chassis_details?.filter(
            item => groupedData[index].chassis_details.includes(item.chassis_no)
        );
        const allVehiclesExited = rowVehicles?.every(item =>
            item.door_exit_date !== null &&
            item.door_exit_date !== undefined &&
            item.door_exit_date !== ""
        );

        if (allVehiclesExited) {
            toast.warning("Bu perondaki tüm araçlar kapı çıkışı yaptığı için seçilemez!", {
                position: "top-center",
                autoClose: 3000
            });
            return;
        }

        setSelectedRow(selectedRow === index ? null : index);
    }, [selectedRow, groupageDetails?.chassis_details, groupedData]);

    const validatePeron = () => {
        var result = true
        if (selectedRow === null) {
            toast.error("Lütfen değiştirmek istediğiniz lokasyon ve peron satırını seçiniz.")
            result = false
            return false

        }
        if (document.getElementById('peron-select').childNodes[0].childNodes[0].value === "") {
            toast.error("Lütfen bir peron seçiniz")
            result = false
            return false
        }
        return result
    }

    return (
        <Modal
            isOpen={isOpen.peronGuncelle}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showTitle={true}
            style={{ maxWidth: "90%", width: "90vw", height: "90vh" }}
            position={{
                my: 'top',
                at: 'top',
                of: window,
                offset: '0 10',
            }}
        >
            <ModalHeader toggle={() => {
                setIsOpen({ ...isOpen, peronGuncelle: false });
            }}>
                Peron Güncelle
            </ModalHeader>
            {groupageDetails?.chassis_details === undefined ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            ) : (
                <div className="p-4">
                    {/* Detay Tablosu */}
                    <div className="mb-4">
                        <h6 className="mb-3">Araç Detayları</h6>
                        <DataGrid
                            showRowLines={true}
                            showColumnLines={true}
                            dataSource={groupageDetails?.chassis_details || []}
                            showBorders={true}
                            height={300}
                            allowColumnResizing={true}
                            width="100%"
                            columnAutoWidth={true}
                        >
                            <Column caption='Grupaj No' dataField='groupage_no' alignment='center' calculateDisplayValue={() => groupageDetails.groupage_no} width={122} />
                            <Column caption='Şase' dataField='chassis_no' alignment='center' width={147} />
                            <Column caption='Model Adı' dataField='model' alignment='center' />
                            <Column caption='Renk Adı' dataField='color' alignment='center' />
                            <Column caption='Nereden' dataField='exit_warehouse' alignment='center' />
                            <Column caption='Nereye' dataField='target' alignment='center' calculateDisplayValue={(row) => row.target + " - " + row.city_name + " / " + row.district_name} />
                            <Column caption='Grupaj Peronu' dataField='groupage_peron' alignment='center' />
                            <Column caption='Stok Adresi' dataField='park_address' alignment='center' />
                            <Column caption='PDI' dataField='pdi_status' alignment='center' width={50} />
                        </DataGrid>
                    </div>

                    {/* Özet Tablosu */}
                    <div>
                        {selectedRow !== null && selectedRowVehiclesExited ? (
                            <div className="alert alert-warning mb-3" role="alert" style={{
                                fontSize: '16px',
                                fontWeight: 'bold',
                                backgroundColor: '#ffadad',
                                border: '2px solid #ff0000',
                                color: '#cc0000',
                                padding: '15px',
                                borderRadius: '8px',
                                textAlign: 'center'
                            }}>
                                ⚠️ Seçili satırdaki tüm araçlar kapı çıkışı yaptığı için peron güncellenemez!
                            </div>
                        ) : (
                            <>
                                <h6 className="mb-3" style={{ background: "#ffadad", width: "max-content" }}>Değiştirme istediğiniz locasyon ve Peron Satırını seçiniz</h6>
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr style={{ background: "#15137C" }}>
                                                <th style={{ color: "white" }}>Nereden</th>
                                                <th style={{ color: "white" }}>Peron</th>
                                                <th style={{ width: '100px', textAlign: 'center', color: "white" }}>Adet</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {groupedData.map((item, index) => {
                                                return (
                                                    <tr
                                                        key={`${item.exit_warehouse_id}-${item.mevcut_peron}`}
                                                        onClick={() => {
                                                            if (!(selectedRow === index)) getPeron(item.exit_warehouse_id)
                                                            handleRowClick(index, item.exit_warehouse_id)
                                                        }}
                                                        style={{
                                                            backgroundColor: selectedRow === index ? 'rgb(251 255 0)' : 'transparent',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        <td style={{ border: "1px solid #ddd" }}>{item.nereden}</td>
                                                        <td style={{ border: "1px solid #ddd" }}>{item.mevcut_peron}</td>
                                                        <td style={{ textAlign: 'center', border: "1px solid #ddd" }}>{item.count}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>

                    <hr />
                    {selectedRow !== null ? (
                        <>
                            {!selectedRowVehiclesExited && (
                                <PeronSecimi
                                    peronRef={peronRef}
                                    warehouseId={groupedData[selectedRow]?.exit_warehouse_id}
                                    selectedVehicles={selectedVehicles}
                                    selectedRow={selectedRow}
                                    groupedData={groupedData}
                                />
                            )}
                        </>
                    ) : (
                        <div className="alert alert-secondary mt-4" role="alert" style={{ color: "black" }}>
                            Lütfen değiştirmek istediğiniz lokasyon ve peron satırını seçiniz.
                        </div>
                    )}

                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <button
                            className="btn btn-secondary mr-2"
                            disabled={selectedRow === null || selectedRowVehiclesExited}
                            onClick={async () => {
                                if (validatePeron()) {
                                    const body = {
                                        "address_id": Number(document.getElementById('peron-select').childNodes[0].childNodes[0].value),
                                        "groupage_no": groupageDetails.groupage_no,
                                        "update_user_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
                                        "chassis_nos": groupedData[selectedRow].chassis_details
                                    };
                                    const response = await updatePlatform(body)
                                    if (response.success) {
                                        await detail()
                                        if (peronRef.current) peronRef.current.instance.reset()
                                        setSelectedRow(null)
                                        toast.success("Peron Güncelleme Başarılı")
                                        onFilter()
                                    }
                                }
                            }}
                        >
                            Güncelle
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={() => setIsOpen({ ...isOpen, peronGuncelle: false })}
                        >
                            İptal
                        </button>
                    </div>
                </div>
            )}
        </Modal>
    )
}

export default PeronGuncelle